module.exports = __webpack_public_path__ + "img/arrow_down_active.9a08f00d.svg";